'use client';

import { Button, Center, HStack, Box, Text } from '@chakra-ui/react';
import { useQueryState } from 'nuqs';
import { FaClock, FaLocationDot, FaStar } from 'react-icons/fa6';
import { useTranslations } from 'next-intl';

const CategoriesList = () => {
  const [filterQuery, setFilterQuery] = useQueryState('filter');
  const t = useTranslations();

  const handleSelect = (query: 'nearby' | 'open' | 'rating') => {
    setFilterQuery(prev => prev === query ? null : query);
  };

  return (
    <Box py={{ base: 3, lg: 4 }} px={{ base: 4, lg: 14 }}>
      <HStack
        flexWrap={{ base: 'nowrap' }}
        overflowX='auto'
        scrollbar='hidden'
        align='stretch'
        alignItems='flex-start'
        gap='3'
      >
        <FilterItem isActive={filterQuery === 'nearby'} onClick={() => handleSelect('nearby')} icon={<FaLocationDot size={24} />} label={t('nearby')} />
        <FilterItem isActive={filterQuery === 'open'} onClick={() => handleSelect('open')} icon={<FaClock size={24} />} label={t('open_now')} />
        <FilterItem isActive={filterQuery === 'rating'} onClick={() => handleSelect('rating')} icon={<FaStar size={24} />} label={t('rating')} />
      </HStack>
    </Box>
  );
};


const FilterItem = ({
  onClick,
  icon,
  label,
  isActive,
}: {
  isActive: boolean;
  onClick: () => void;
  icon: React.ReactNode;
  label: string;
}) => {
  return (
    <Button
      onClick={onClick}
      variant='plain'
      flexDirection='column'
      h='100%'
      p='0'
      gap='1'
    >
      <Center
        width='48px'
        height='48px'
        rounded='full'
        bg={isActive ? 'primary' : '#F5F4F3'}
        color={isActive ? 'white' : 'inherit'}
      >
        {icon}
      </Center>
      <Text
        fontWeight={500}
        fontSize='14px'
      >
        {label}
      </Text>
    </Button>
  );
};

export default CategoriesList;
